import { Grid, InputLabel } from '@material-ui/core';
import React, { useState } from 'react';
import { DatePicker, SecondaryButton, SingleSelect } from '../../../../../../Core/Controls';
import { Alert } from '@material-ui/lab';
import { postJobStepSignOff } from '../../../../../../Core/Services/InternalUser/ControllerService/jobStepperService';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const JobTechSignOff = ({ handleNext, jobDetails, isEngineer, isDisabled, isServiceAgent }) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();

    const [btnLoader, setBtnLoader] = useState(false);
    const history = useHistory();
    const [state, setState] = useState({
        completionDate: moment().format('YYYY-MM-DD')
    });

    const handleSubmit = async () => {
        if (!state.completionDate) {
            showToastWarning('Completion date cannot be empty');
            return false;
        }
        setBtnLoader(true);
        let res = await postJobStepSignOff(jobDetails.jobID, state.completionDate);
        if (res.success) {
            showToastSuccess(res.data.message);
            history.push('/');
            setBtnLoader(false);
            handleNext();
        } else {
            showToastError(res.message);
            setBtnLoader(false);
        }
    };

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };
    return (
        <div style={{ padding: 10 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="warning">
                        {isEngineer || isServiceAgent
                            ? 'Please click the Sign Off button below if you have completed the job'
                            : 'Please login as technician/service area to sign off the job'}
                    </Alert>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel shrink style={{ marginBottom: 5 }} error required>
                        Job Completion Date
                    </InputLabel>
                    <DatePicker value={state.completionDate} onChange={handleChange} name="completionDate" />
                </Grid>
                {(isEngineer || isServiceAgent) && isDisabled && (
                    <Grid item xs={12}>
                        <SecondaryButton onClick={handleSubmit} isBtnLoader={btnLoader}>
                            Sign Off
                        </SecondaryButton>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default JobTechSignOff;
